import { render } from "./ButtonColumn.vue?vue&type=template&id=072754d8"
import script from "./ButtonColumn.vue?vue&type=script&lang=js"
export * from "./ButtonColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__